type Collection = Record<string, string>;

export const CONTROLS_AND_ELEMENTS_IDS: Collection = {
  // Search Bar, Thumbs Up/Down, Share
  TOP_BAR: 'playback-top-menu-wrapper',
  // Timeline wrapper
  TIMELINE: 'timeline-container',
  // Player Controls Container
  PLAYER_CONTROLS_CONTAINER: 'player-controls-container',
  // Pay/Pause/Replay Button
  PLAY_PAUSE_BUTTON: 'play-pause-replay-button',
  // Player time info
  PLAYER_TIME_INFO: 'time-info',
  // Highlights and Reactions container
  HIGHLIGHTS_REACTIONS_CONTAINER: 'highlights-reactions-container',
  // Recording controls (Prev/next recording, Settings, and side panel toggle) container
  RECORDING_CONTROLS_CONTAINER: 'recording-controls-container',
  // Relevant Actions container
  RELEVANT_ACTIONS_CONTAINER: 'relevant-actions-container',
  // Comments Container
  COMMENTS_CONTAINER: 'comments-container',
  // Selection Tooltip
  SELECTION_TOOLTIP: 'control-selection-tooltip',
  // Address Bar
  ADDRESS_BAR: 'address-bar',
};

export const CONTROLS_AND_ELEMENTS_SELECTORS: Collection = Object.keys(
  CONTROLS_AND_ELEMENTS_IDS,
).reduce<Collection>((acc: Collection, item: string) => {
  acc[item] = `#${CONTROLS_AND_ELEMENTS_IDS[item]}`;
  return acc;
}, {});
